module.exports = __webpack_public_path__ + "static/media/scrolling.4a46b7e3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/patient-hope/scrolling.gif
// module id = 372
// module chunks = 0